export default __webpack_public_path__ + "static/media/Union.8d894135.svg";